import { createFileRoute } from "@tanstack/react-router";
import DiagnosedDepressionSecondHalfOfLife from "@/pages/articles/DiagnosedDepressionSecondHalfOfLife";
export const Route = createFileRoute("/depression-in-the-second-half-of-life")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression In The Second Half Of Life | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression in older adults is not a normal part of aging. Learn about TMS, SAINT TMS, and treatment options in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Depression In The Second Half Of Life | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression in older adults is not a normal part of aging. Learn about TMS, SAINT TMS, and treatment options in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/depression-in-the-second-half-of-life",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-in-the-second-half-of-life",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DiagnosedDepressionSecondHalfOfLife />;
}
